import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../common/services/cqs/IPrimaryKey";

export class MergeAllDestineringsalternativCommand extends BasicCommand<MergeAllDestineringsalternativCommand> {
    get primaryKey(): IPrimaryKey<MergeAllDestineringsalternativCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    checkAddIntressent: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "MergeAllDestineringsalternativCommand";
    constructor(init: (instance: MergeAllDestineringsalternativCommand) => void) {
        super(MergeAllDestineringsalternativCommand.$type, MergeAllDestineringsalternativCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
